
import { MobileOptimizedNavigation } from "@/components/mobile/MobileOptimizedNavigation";
import { MobileNavigation } from "@/components/MobileNavigation";
import { Navigation } from "@/components/Navigation";
import { Dashboard } from "@/components/Dashboard";
import { MobileViewportMeta } from "@/components/mobile/MobileViewportMeta";
import { useIsMobile } from "@/hooks/use-mobile";

export default function DashboardPage() {
  const isMobile = useIsMobile();

  return (
    <>
      <MobileViewportMeta />
      <div className="min-h-screen bg-background">
        {isMobile ? <MobileOptimizedNavigation /> : <Navigation />}
        
        <div className={`${isMobile ? 'pt-16 pb-6' : 'pt-16 pb-20 md:pb-6'} ios-safe-area-bottom`}>
          <div className={`${isMobile ? 'px-4 py-4' : 'container mx-auto px-4 py-6'}`}>
            <Dashboard />
          </div>
        </div>
        
        {!isMobile && <MobileNavigation />}
      </div>
    </>
  );
}
